export const CONVERSATION_MARKER_RE =
  /^# kizen-ai-conversation: ([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})[ \t]*$/;

export const parseConversationMarker = (script: unknown): string | null => {
  if (typeof script !== 'string') return null;
  const trimmed = script.trimEnd();
  const lastLine = trimmed.slice(trimmed.lastIndexOf('\n') + 1);
  const [firstLine = ''] = script.split('\n', 1);
  return (
    CONVERSATION_MARKER_RE.exec(lastLine)?.[1] ??
    CONVERSATION_MARKER_RE.exec(firstLine.replace(/\r$/, ''))?.[1] ??
    null
  );
};

interface StepsState {
  steps: { id: string; details?: unknown }[];
}

export const readStepConversationMarker = (
  state: StepsState,
  stepId: string
): string | null => {
  const step = state.steps.find(({ id }) => id === stepId);
  const details = step?.details as { script?: unknown } | undefined;
  return parseConversationMarker(details?.script);
};
